import { render } from "./ZhilLiaoView.vue?vue&type=template&id=0442a1c9&scoped=true&ts=true"
import script from "./ZhilLiaoView.vue?vue&type=script&lang=ts"
export * from "./ZhilLiaoView.vue?vue&type=script&lang=ts"

import "./ZhilLiaoView.vue?vue&type=style&index=0&id=0442a1c9&lang=scss&scoped=true"

import exportComponent from "C:\\vue项目\\fushuliang2024\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0442a1c9"]])

export default __exports__